"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheAdvantage() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="146437" id="gum-treatment-overview" className="bg-background text-foreground w-full overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 items-stretch">
          
          {/* Content Column */}
          <div ref={textRef} className={`lg:col-span-7 py-16 lg:py-32 lg:pr-16 relative flex flex-col justify-center transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="flex items-center gap-4 mb-8">
              <div className="w-12 h-px bg-primary/40"></div>
              <span className="font-sans text-primary text-sm tracking-widest uppercase">
                Periodontoloji
              </span>
            </div>
            
            <h2 className="font-serif text-5xl md:text-7xl lg:text-8xl leading-none mb-8 uppercase tracking-[0.1em] font-light text-foreground">
              Diş Eti Sağlığı
            </h2>
            
            <p className="text-muted-foreground text-lg md:text-xl leading-relaxed max-w-2xl font-sans">
              Sağlıklı bir gülüşün temeli, güçlü diş etleridir. Periodontal sağlık, sadece estetik bir görünüm değil, aynı zamanda genel vücut sağlığınızın da korunması anlamına gelir. Modern tedavi yöntemlerimiz ve uzman yaklaşımımızla, diş eti hastalıklarını önleyerek dişlerinizin ömrünü uzatıyor ve size ışıltılı bir gelecek sunuyoruz.
            </p>

            {/* Vertical separator */}
            <div className="hidden lg:block absolute right-0 top-0 bottom-0 w-px bg-primary/20"></div>
          </div>

          {/* Image Column */}
          <div ref={imgRef} className={`lg:col-span-5 relative min-h-[400px] lg:min-h-full transition-all duration-1000 delay-300 ease-out ${isImgVisible ? "opacity-100" : "opacity-0"}`}>
            {/* Frame-within-a-frame effect */}
            <div className="absolute inset-0 p-10">
              <div className="w-full h-full border-[0.5px] border-primary/60 relative overflow-hidden">
                {/* Overlay removed for radiant high-key look */}
                <div className="absolute inset-0 bg-primary/5 z-10 mix-blend-soft-light"></div>
                
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/healthy_smile_clinical.png" alt="Healthy radiant smile" className="absolute inset-0 w-full h-full object-cover" />
              </div>
            </div>
            
            {/* Horizontal separator for mobile */}
            <div className="block lg:hidden absolute top-0 left-0 right-0 h-px bg-primary/20"></div>
          </div>

        </div>
      </div>
    </section>;
}